import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../theme';

const { colors, fonts, fontSize, spacing, breakpoints } = redesignTheme;

export const useCustomEbookBlockStyles = makeStyles(() => ({
  blockText: {
    color: colors.primaryDark,
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    lineHeight: 1.5,
    wordBreak: 'break-word',
    '& p': {
      marginTop: 0,
      marginBottom: spacing.sm,
    },
    '& p:last-child': {
      marginBottom: 0,
    },
    '& strong, & b': {
      fontFamily: fonts.opensansBold,
    },
    '& img, & video, & iframe, & table': {
      maxWidth: '100%',
    },
  },
  title: {
    margin: 0,
    color: colors.primaryDark,
    fontFamily: fonts.opensansBold,
    fontSize: 24,
    lineHeight: 1.35,
    wordBreak: 'break-word',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      fontSize: fontSize.lg,
    },
  },
  subtitle: {
    margin: 0,
    color: colors.primaryDark,
    fontFamily: fonts.opensansBold,
    fontSize: 18,
    lineHeight: 1.35,
    wordBreak: 'break-word',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      fontSize: fontSize.base,
    },
  },
  summary: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    marginTop: spacing.sm,
  },
  summaryTitle: {
    margin: 0,
    color: colors.primaryDark,
    fontFamily: fonts.gothicSemiBold,
    fontSize: 18,
    lineHeight: 1.3,
  },
  summaryGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  summaryLink: {
    padding: 0,
    border: 0,
    background: 'transparent',
    color: colors.textBody,
    cursor: 'pointer',
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    lineHeight: 1.45,
    textAlign: 'left',
    wordBreak: 'break-word',
    '&:hover': {
      color: colors.primary,
    },
  },
  summaryChapter: {
    color: colors.primaryDark,
    fontSize: fontSize.base,
    fontFamily: fonts.opensansBold,
  },
  quote: {
    padding: '40px 0',
    color: colors.primary,
    textAlign: 'center',
    fontFamily: fonts.opensans,
  },
  quoteText: {
    margin: 0,
    fontSize: fontSize.base,
    fontStyle: 'italic',
    fontFamily: fonts.opensansSemiBold,
    lineHeight: 1.45,
    '&:before, &:after': {
      color: colors.primary,
      fontSize: 22,
      lineHeight: 0,
    },
    '&:before': {
      content: '"\\201C  "',
    },
    '&:after': {
      content: '" \\201D"',
    },
  },
  quoteAuthor: {
    marginTop: spacing.sm,
    fontSize: fontSize.base,
    fontFamily: fonts.opensansBold,
  },
  encyclopedia: {
    display: 'flex',
    gap: spacing.sm,
    padding: spacing.md,
    border: `1px solid rgba(0, 10, 141, 0.08)`,
    borderRadius: 5,
    backgroundColor: 'rgba(0, 10, 141, 0.04)',
    color: colors.primaryDark,
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    lineHeight: 1.5,
    wordBreak: 'break-word',
  },
  encyclopediaIcon: {
    width: 24,
    height: 24,
    flex: '0 0 auto',
    color: colors.primary,
    fontSize: 24,
    lineHeight: '24px',
  },
  imageWrap: {
    padding: '20px 0',
  },
  image: {
    width: '100%',
    height: 'auto',
    display: 'block',
  },
  videoWrap: {
    '& iframe': {
      width: '100%',
      maxWidth: '100%',
    },
  },
  question: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
  },
  questionTitle: {
    margin: 0,
    padding: '4px 8px',
    backgroundColor: 'rgba(0, 10, 141, 0.04)',
    color: colors.primaryDark,
    fontFamily: fonts.opensansBold,
    fontSize: fontSize.md,
    lineHeight: 1.45,
    whiteSpace: 'break-spaces',
    wordBreak: 'break-word',
  },
  answerList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  otherAnswer: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
  },
  answerLabel: {
    display: 'flex',
    alignItems: 'center',
    margin: 0,
    color: colors.primaryDark,
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    lineHeight: 1.5,
    '& .MuiFormControlLabel-label': {
      color: colors.primaryDark,
      fontFamily: fonts.opensans,
      fontSize: fontSize.md,
      lineHeight: 1.5,
      wordBreak: 'break-word',
    },
  },
  choiceControl: {
    padding: 0,
    marginRight: 12,
    color: `${colors.border} !important`,
    '&.Mui-checked': {
      color: `${colors.primaryDark} !important`,
    },
  },
  textarea: {
    width: '100%',
    minHeight: 56,
    padding: spacing.xs,
    boxSizing: 'border-box',
    border: 0,
    resize: 'vertical',
    backgroundColor: '#f4f4f4',
    color: colors.primaryDark,
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.sm,
    lineHeight: 1.45,
    outline: 'none',
    '&::placeholder': {
      color: '#838183',
      opacity: 1,
    },
    '&:focus': {
      boxShadow: `0 0 0 2px ${colors.primary}`,
    },
    '&:read-only': {
      color: '#838183',
    },
  },
}));
